import { useState } from 'react';
import { Container, Grid } from '@mui/material';
import '../styles.scss';

export default function Pregunta11({ setRespuesta, cambiarPregunta, sumarPuntos }) {
	const [seleccionadas, setSeleccionada] = useState([]);
	const [btn1, setBtn1] = useState(false);
	const [btn2, setBtn2] = useState(false);
	const [btn3, setBtn3] = useState(false);
	const [btn4, setBtn4] = useState(false);
	const [correctas] = useState(['b) Comunicar la razón y el propósito detrás del cambio.', 'a) Explicar los procesos y recursos para implementar el cambio.', 'c) Indicar qué implica el cambio y cómo se medirá el éxito.']);
	const [paso1, setPaso1] = useState(null);
	const [paso2, setPaso2] = useState(null);
	const [paso3, setPaso3] = useState(null);
	const [paso4, setPaso4] = useState(null);
	const [pasos, setPasos] = useState(1);

	const grabarSeleccionada = (opc, btn) => {
		const array = seleccionadas;
		array.push(opc);
		setSeleccionada(array);
		setPasos(pasos + 1);

		if (btn === 1) {
			setPaso1(pasos);
		}
		if (btn === 2) {
			setPaso2(pasos);
		}
		if (btn === 3) {
			setPaso3(pasos);
		}
		if (btn === 4) {
			setPaso4(pasos);
		}
	};

	const siguiente = () => {
		if (seleccionadas.toString() === correctas.toString()) {
			setRespuesta('pregunta11', seleccionadas, 1);
			console.log('si');

			sumarPuntos(1);
		} else {
			setRespuesta('pregunta11', seleccionadas, 0);
			console.log('no');

			sumarPuntos(0);
		}
		cambiarPregunta(12);
	};

	return (
		<>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='pregunta'>
							<div className='num-pregunta'>11.</div> Debes comunicar a tus asesores un cambio en las políticas de servicio que impactará en sus objetivos. A partir de lo aprendido, ordena las acciones que llevarías a cabo de acuerdo con el Círculo dorado
						</div>
					</Grid>
					<Grid item xs={11} sm={11} md={11} lg={11}>
						<div
							className={`${btn1 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn1(true);
								grabarSeleccionada('a) Explicar los procesos y recursos para implementar el cambio.', 1);
							}}
						>
							<div className='letra'>{`a)`}</div>
							<div className='texto-respuesta'>Explicar los procesos y recursos para implementar el cambio.</div>
						</div>
					</Grid>
					<Grid item xs={1} sm={1} md={1} lg={1}>
						<div className='num-pregunta'>{paso1}</div>
					</Grid>
					<Grid item xs={11} sm={11} md={11} lg={11}>
						<div
							className={`${btn2 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn2(true);
								grabarSeleccionada('b) Comunicar la razón y el propósito detrás del cambio.', 2);
							}}
						>
							<div className='letra'>{`b)`}</div>
							<div className='texto-respuesta'>Comunicar la razón y el propósito detrás del cambio.</div>
						</div>
					</Grid>
					<Grid item xs={1} sm={1} md={1} lg={1}>
						<div className='num-pregunta'>{paso2}</div>
					</Grid>
					<Grid item xs={11} sm={11} md={11} lg={11}>
						<div
							className={`${btn3 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn3(true);
								grabarSeleccionada('c) Indicar qué implica el cambio y cómo se medirá el éxito.', 3);
							}}
						>
							<div className='letra'>{`c)`}</div>
							<div className='texto-respuesta'> Indicar qué implica el cambio y cómo se medirá el éxito.</div>
						</div>
					</Grid>
					<Grid item xs={1} sm={1} md={1} lg={1}>
						<div className='num-pregunta'>{paso3}</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='siguiente' onClick={() => siguiente()}>
							Siguiente
						</div>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}
